import { render, staticRenderFns } from "./CommentStar.vue?vue&type=template&id=3267dd40&scoped=true&"
import script from "./CommentStar.vue?vue&type=script&lang=js&"
export * from "./CommentStar.vue?vue&type=script&lang=js&"
import style0 from "./CommentStar.vue?vue&type=style&index=0&id=3267dd40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3267dd40",
  null
  
)

export default component.exports